import { Box, TextField } from "@mui/material";
import { useRef } from "react";

const OtpInputMui = ({ length = 6, onChange }) => {
  const inputRefs = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value.slice(-1);
    e.target.value = value;

    if (value && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    updateCode();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, length);
    pasteData.split("").forEach((char, idx) => {
      if (inputRefs.current[idx]) {
        inputRefs.current[idx].value = char;
      }
    });

    const nextIndex = pasteData.length < length ? pasteData.length : length - 1;
    inputRefs.current[nextIndex]?.focus();

    updateCode();
  };

  const updateCode = () => {
    const code = inputRefs.current.map((input) => input?.value || "").join("");
    onChange(code);
  };

  return (
    <Box display="flex" gap={2}>
      {Array.from({ length }).map((_, index) => (
        <TextField
          key={index}
          inputProps={{
            maxLength: 1,
            style: { textAlign: "center", fontSize: "20px" },
          }}
          inputRef={(el) => (inputRefs.current[index] = el)}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
          variant="outlined"
          size="small"
        />
      ))}
    </Box>
  );
};

export default OtpInputMui;
